import { render } from "./Antwoord.vue?vue&type=template&id=c3541950"
import script from "./Antwoord.vue?vue&type=script&lang=js"
export * from "./Antwoord.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__